define(
    [
        'assets/js/modules/pricing/pricingModel',
        'assets/js/modules/pricing/freePricingModel',
        'assets/js/modules/pricing/pricePerQuantityPricingModel',
        'assets/js/modules/pricing/percentagePricingModel',
        'assets/js/modules/pricing/percentageSubPricingModel',
        'assets/js/modules/pricing/surchargePricingModel'
    ],
    function(
        PricingModel,
        FreePricingModel,
        PricePerQuantityPricingModel,
        PercentagePricingModel,
        PercentageSubPricingModel,
        SurchargePricingModel
    ) {
        return {
            /**
             * @param {Object} dto
             * @returns {PricingModel|undefined}
             */
            fromDTO: function(dto) {
                switch (dto.strategy) {
                    case PricingModel.STRATEGY_FREE:
                        return new FreePricingModel();

                    case PricingModel.STRATEGY_PRICE_PER_QUANTITY:
                    case PricingModel.STRATEGY_PRICE_PER_QUANTITY_PLUS_BASE:
                        return new PricePerQuantityPricingModel({
                            price: dto.price,
                            quantity: dto.quantity,
                            basePrice: dto.base || 0,
                            currency: dto.currency
                        });

                    case PricingModel.STRATEGY_PERCENTAGE:
                        return new PercentagePricingModel({
                            percentage: dto.percentage,
                            basedOn: dto.basedOn
                        });

                    case PricingModel.STRATEGY_PERCENTAGE_SUB:
                        return new PercentageSubPricingModel({
                            percentage: dto.percentage,
                            basedOn: dto.basedOn
                        });

                    case PricingModel.STRATEGY_SURCHARGE:
                        return new SurchargePricingModel({
                            productSlug: dto.product
                        });

                    default:
                        new Error('Unknown strategy');
                        return;
                }
            }
        };
    }
);
